<div class="flex h-full flex-column md:flex-row">
  <div
    class="surface-0 pt-3 pb-3 h-full flex flex-column gap-3 flex-grow-1 surface-border border-right-1 md:max-w-23rem w-full">
    <div class="px-3 flex flex-column gap-3">
      <div class="surface-border border-1 border-round-xl surface-0 p-4 w-max">
        <app-logo hStyleClass="h-8rem w-12rem" [logoFileName]="config?.logo" />
      </div>

      <h1 class="m-0 text-2xl mb-5 font-semibold">
        {{
          config.headline ||
            globalStore.activeCommune()?.title ||
            globalStore.activeCommune()?.name
        }}
      </h1>

      <div
        class="surface-border border-1 pl-4 pr-2 py-2 w-full md:w-20rem flex flex-column cursor-pointer hover:shadow-8 transition-all transition-duration-300 border-round"
        (click)="callSearch()">
        <header>
          <h3 class="m-0 flex align-items-center gap-3 text-l font-semibold">
            <span>Suche</span>
            <div
              class="bg-primary border-round-3xl ml-auto w-3rem h-3rem flex flex-shrink-0 justify-content-center align-items-center">
              <i class="fas fa-search"></i>
            </div>
          </h3>
        </header>
      </div>

      <div
        class="surface-border border-1 pl-4 pr-2 py-2 w-full md:w-20rem flex flex-column cursor-pointer hover:shadow-8 transition-all transition-duration-300 border-round"
        (click)="closeLandingPage()">
        <header>
          <h3 class="m-0 flex align-items-center gap-3 text-l font-semibold">
            <span>Erstellen</span>
            <div
              class="bg-primary border-round-3xl ml-auto w-3rem h-3rem flex flex-shrink-0 justify-content-center align-items-center">
              <i class="fas fa-screwdriver-wrench"></i>
            </div>
          </h3>
        </header>
      </div>
    </div>

    <footer class="mt-auto flex flex-column gap-3">
      <div class="px-3">
        <div class="flex gap-3">
          <p-button
            label="Indikatoren"
            styleClass="surface-border"
            [outlined]="true"
            icon="fas fa-folder-tree"
            [rounded]="true"
            (click)="showTree()"></p-button>
          <p-button
            class="ml-auto"
            styleClass="surface-border"
            [outlined]="true"
            icon="fas fa-info"
            [rounded]="true"
            (click)="showInfo()"></p-button>
          <p-button
            styleClass="surface-border"
            [outlined]="true"
            icon="fas fa-ellipsis-vertical"
            [rounded]="true"
            (onClick)="menu.toggle($event)" />
        </div>
        <p-menu #menu [model]="menuItems" [popup]="true" styleClass="w-20rem">
          <ng-template pTemplate="item" let-item>
            @if (item.url) {
              <a class="p-menuitem-link" target="_blank" [href]="item.url">
                <div class="flex align-items-center">
                  <i class="p-menuitem-icon" [class]="item.icon"></i>
                  <div>
                    <span>{{ item.label }}</span>
                    @if (item.sub) {
                      <div class="text-xs text-color-secondary mt-2">
                        {{ item.sub }}
                      </div>
                    }
                  </div>
                </div>
              </a>
            } @else {
              <a
                class="p-menuitem-link"
                [routerLink]="item.routerLink"
                [target]="item.target || '_self'">
                <div class="flex align-items-center">
                  <i class="p-menuitem-icon" [class]="item.icon"></i>
                  <div>
                    <span>{{ item.label }}</span>
                    @if (item.sub) {
                      <div class="text-xs text-color-secondary mt-2">
                        {{ item.sub }}
                      </div>
                    }
                  </div>
                </div>
              </a>
            }
          </ng-template>
        </p-menu>
      </div>

      <div class="">
        <div class="flex flex-column gap-3">
          <div
            class="w-full px-3 py-3 border-top-1 border-bottom-1 surface-border">
            <app-logo hStyleClass="h-7rem w-20rem" />
          </div>
          <div class="flex gap-3 px-3">
            <a
              class="text-color font-semibold no-underline hover:underline text-sm"
              href="#"
              >Impressum</a
            >
            <a
              class="text-color font-semibold no-underline hover:underline text-sm"
              href="#"
              >Datenschutz</a
            >
          </div>
        </div>
      </div>
    </footer>
  </div>
  <div class="surface-ground w-full">
    <p-scrollPanel [style]="{ width: '100%', height: '100vh' }">
      <div class="grid p-3 w-full">
        @if (globalStore.communeConfiguration(); as config) {
          @if (fallbackTopic(); as topic) {
            <div
              [ngClass]="topic.spotlight ? 'xl:col-8' : 'xl:col-4'"
              class="md:col-6 col-12 flex">
              <div
                class="p-4 p-card flex flex-grow-1 flex-column border-round-xl"
                [ngClass]="
                  topic.spotlight
                    ? [
                        'hover:shadow-8 transition-all transition-duration-300',
                        getTopicAccentClasses(topic.color)?.bgStrong ||
                          'bg-primary',
                      ]
                    : ''
                ">
                <header>
                  <h3
                    class="mt-0 mb-2 flex align-items-center gap-3 font-semibold"
                    [ngClass]="{
                      'text-xl': topic.title.length > 20,
                      'text-2xl': topic.title.length <= 20,
                    }">
                    <span [class.text-white]="topic.spotlight">{{
                      topic.title
                    }}</span>
                    <div
                      class="border-round-xl ml-auto w-3rem h-3rem flex flex-shrink-0 justify-content-center align-items-center text-base"
                      [ngClass]="
                        topic.spotlight
                          ? 'surface-0'
                          : getTopicAccentClasses(topic.color)?.bgStrong ||
                            'bg-primary'
                      ">
                      <i
                        class="fas"
                        [ngClass]="
                          topic.spotlight
                            ? [
                                'fa-' + topic.icon,
                                getTopicAccentClasses(topic.color)
                                  ?.textStrong || 'text-primary',
                              ]
                            : ['fa-' + topic.icon, 'text-white']
                        "></i>
                    </div>
                  </h3>
                </header>
                @if (topic.description) {
                  <div
                    class="pb-3"
                    [class.text-white]="topic.spotlight"
                    [innerHtml]="topic.description"></div>
                }
                <footer class="mt-auto">
                  <p-button
                    [rounded]="true"
                    label="Thema aufrufen"
                    styleClass="icon-inset"
                    icon="fas fa-arrow-right"
                    (click)="openFallbackTopic()"></p-button>
                </footer>
              </div>
            </div>
          }
          @if (checkDefaultBookmark()) {
            <div
              class="xl:col-8 md:col-6 col-12 flex"
              (click)="callStartPage()">
              <div
                class="p-card p-4 flex flex-grow-1 flex-column bg-primary cursor-pointer hover:shadow-8 transition-all transition-duration-300 border-round-xl">
                <header>
                  <h3
                    class="mt-0 mb-2 flex align-items-center gap-3 text-4xl font-semibold">
                    <span>Start</span>
                  </h3>
                </header>
                @if (config.startTeaser; as teaser) {
                  <div [innerHTML]="teaser"></div>
                }
                <footer class="mt-auto">
                  <p-button
                    [rounded]="true"
                    label="Startansicht laden"
                    styleClass="icon-inset"
                    icon="fas fa-arrow-right"></p-button>
                </footer>
              </div>
            </div>
          }
          @if (landingPageItems.length) {
            @for (item of landingPageItems; track $index) {
              @if (enhancedLandingPageItem(item); as landingPageItem) {
                <div
                  [ngClass]="
                    landingPageItem.spotlight ? 'xl:col-8' : 'xl:col-4'
                  "
                  class="md:col-6 col-12 flex">
                  <div
                    class="p-4 p-card flex flex-grow-1 flex-column border-round-xl"
                    [ngClass]="
                      landingPageItem.spotlight
                        ? [
                            'hover:shadow-8 transition-all transition-duration-300',
                            getTopicAccentClasses(landingPageItem.color)
                              ?.bgStrong || 'bg-primary',
                          ]
                        : ''
                    ">
                    <header>
                      <h3
                        class="mt-0 mb-2 flex align-items-center gap-3 font-semibold"
                        [ngClass]="{
                          'text-xl': landingPageItem.name.length > 20,
                          'text-2xl': landingPageItem.name.length <= 20,
                        }">
                        <span
                          [class.text-white]="landingPageItem.spotlight"
                          style="overflow-wrap: anywhere">
                          {{ landingPageItem.name }}</span
                        >
                        <div
                          class="border-round-xl ml-auto w-3rem h-3rem flex flex-shrink-0 justify-content-center align-items-center text-base"
                          [ngClass]="
                            landingPageItem.spotlight
                              ? 'surface-0'
                              : getTopicAccentClasses(landingPageItem.color)
                                  ?.bgStrong || 'bg-primary'
                          ">
                          <i
                            [class]="landingPageItem.icon || ''"
                            [ngClass]="
                              landingPageItem.spotlight
                                ? getTopicAccentClasses(landingPageItem.color)
                                    ?.textStrong || 'text-primary'
                                : 'text-white'
                            "></i>
                        </div>
                      </h3>
                    </header>

                    @if (landingPageItem.text) {
                      <div
                        class="pb-3"
                        [class.text-white]="landingPageItem.spotlight"
                        [innerHtml]="landingPageItem.text"></div>
                    }
                    <footer class="mt-auto">
                      <p-button
                        [rounded]="true"
                        [label]="getLabelByType(item.type)"
                        styleClass="icon-inset"
                        icon="fas fa-arrow-right"
                        (click)="landingPageItemCTA(item)"></p-button>
                    </footer>
                  </div>
                </div>
              }
            }
          } @else {}
        } @else {
          <h1 class="text-color-secondary m-3">Atlas in Zahlen</h1>
          <div class="w-full flex">
            <app-count-overview />
          </div>
        }
      </div>
    </p-scrollPanel>
  </div>
</div>

<p-dialog
  [modal]="true"
  [(visible)]="treeVisible"
  [style]="{ width: '60rem' }"
  header="Indikatoren explorieren">
  <div class="flex flex-column gap-3">
    @if (indicatorIds.length > 0) {
      <div
        class="-mx-3 p-3 surface-ground flex flex-column gap-3 sticky top-0 z-absolute-top surface-0 border-round-xl surface-border border-1">
        <div class="p-card p-3">
          <app-indicator-selection-list
            [indicatorIds]="indicatorIds"
            (unselectEvent)="
              unselectIndicator($event)
            "></app-indicator-selection-list>
        </div>
        <p-button
          [rounded]="true"
          class="ml-auto"
          label="Daten visualisieren"
          icon="fas fa-bolt"
          (click)="visualizeSelectedIndicators()"></p-button>
      </div>
    }

    <app-atlas-indicator-tree
      [combineableIndicatorIds]="combineableIndicators"
      (selectIndicator)="
        toggleIndicatorSelection($event)
      "></app-atlas-indicator-tree>
  </div>
</p-dialog>

<p-dialog
  [modal]="true"
  [(visible)]="infoVisible"
  [style]="{ width: '60rem' }"
  [breakpoints]="{ '960px': '95vw' }"
  [dismissableMask]="true"
  [focusOnShow]="false">
  <ng-template pTemplate="header">
    <app-header
      styleClass="m-0"
      icon="fas fa-info-circle"
      [text]="'Funktionen auf der Startseite'"></app-header>
  </ng-template>

  <div class="info-overlay">
    <section class="info-overlay__intro">
      <span class="info-overlay__eyebrow">Willkommen im Kommunal-Atlas</span>
      <h2>Kommunale Daten anschaulich und individuell auswerten</h2>
      <p>
        Erkunden Sie Daten Ihrer Stadt, Gemeinde oder Ihres Landkreises einfach
        und interaktiv. Ob kleinräumige Vergleiche, zeitliche Entwicklungen oder
        unterschiedliche Darstellungsformen: Der Atlas hilft dabei,
        Disparitäten, Trends und Zusammenhänge schnell zu erkennen, und schafft
        eine Grundlage für Diskussion, Entscheidung oder Engagement.
      </p>
    </section>

    <h3 class="info-overlay__section-title">
      <i class="fas fa-compass"></i> Erste Orientierung
    </h3>
    <div class="info-overlay__modes">
      <article class="mode">
        <span class="mode__icon mode__icon--plain">
          <i class="fas fa-book-open"></i>
        </span>
        <div>
          <h4>Lesen</h4>
          <p>
            Bereits zusammengestellte Themen, Berichte und Ansichten rufen Sie
            bequem über die weißen Buttons auf.
          </p>
        </div>
      </article>
      <article class="mode">
        <span class="mode__icon">
          <i class="fas fa-pen-ruler"></i>
        </span>
        <div>
          <h4>Selbst gestalten</h4>
          <p>
            Für eigene Auswertungen nutzen Sie die beiden zentralen Funktionen
            <b>Suche</b> und <b>Erstellen</b>.
          </p>
        </div>
      </article>
    </div>

    <h3 class="info-overlay__section-title">
      <i class="fas fa-star"></i> Die Funktionen im Überblick
    </h3>
    <div class="info-overlay__features">
      <article class="feature">
        <header class="feature__header">
          <h4>Suche</h4>
          <span class="feature__icon"><i class="fas fa-search"></i></span>
        </header>
        <p>
          Suchen Sie nach Indikatoren, Räumen oder Ortsteilen, Themen, Berichten
          oder Ansichten. Ein Stichwort genügt: Mit einem Klick erstellt der
          Atlas automatisch eine Ansicht aus verschiedenen Darstellungen.
        </p>
        <ul class="feature__tips">
          <li>
            <span class="key"><i class="fas fa-eye"></i></span>
            Einzelnen Indikator anzeigen
          </li>
          <li>
            <span class="key"><i class="fas fa-plus-circle"></i></span>
            Mehrere Indikatoren kombinieren
          </li>
          <li>
            <span class="key"><i class="fas fa-filter"></i></span>
            Filtern und über Schlagworte eingrenzen
          </li>
        </ul>
        <p-button
          label="Suche öffnen"
          icon="fas fa-arrow-right"
          iconPos="right"
          [rounded]="true"
          [text]="true"
          (click)="infoVisible = false; callSearch()"></p-button>
      </article>

      <article class="feature">
        <header class="feature__header">
          <h4>Erstellen</h4>
          <span class="feature__icon">
            <i class="fas fa-screwdriver-wrench"></i>
          </span>
        </header>
        <p>
          Bauen Sie eigene Ansichten und stellen Sie Ihre Datenansicht
          individuell zusammen. Alles lässt sich flexibel anpassen.
        </p>
        <ul class="feature__chips">
          @for (type of widgetTypes; track type) {
            <li>
              <i [class]="widgetTypeDisplay[type]?.icon"></i>
              {{ widgetTypeDisplay[type]?.label }}
            </li>
          }
        </ul>
        <p-button
          label="Jetzt erstellen"
          icon="fas fa-arrow-right"
          iconPos="right"
          [rounded]="true"
          [text]="true"
          (click)="infoVisible = false; closeLandingPage()"></p-button>
      </article>

      <article class="feature feature--wide">
        <header class="feature__header">
          <h4>Weiße Buttons</h4>
          <span class="feature__icon feature__icon--plain">
            <i class="fas fa-hand-pointer"></i>
          </span>
        </header>
        <p>
          Die weißen Buttons auf der Seite führen Sie direkt zu den Themen,
          Berichten und Ansichten, die für Sie zusammengestellt wurden. So
          finden Sie schnell, was Sie interessiert.
        </p>
      </article>
    </div>

    <footer class="info-overlay__outro">
      <i class="fas fa-rocket"></i>
      <p>
        Schauen Sie sich in Ruhe um, probieren Sie die Funktionen aus und
        entdecken Sie, was in den kommunalen Daten steckt.
        <b>Viel Spaß beim Erkunden!</b>
      </p>
    </footer>
  </div>
</p-dialog>
